import { Search } from 'lucide-react'
import { useUniversalSearch } from './SearchContext'

export default function SearchTrigger({
  label = false,
  onOpen,
}: {
  label?: boolean
  onOpen?: () => void
}) {
  const search = useUniversalSearch()
  if (!search) return null
  return (
    <button
      type="button"
      aria-label="Search Optioneer"
      title="Search Optioneer (⌘K / Ctrl+K)"
      aria-haspopup="dialog"
      aria-expanded={search.isOpen}
      className="inline-flex h-11 min-w-11 shrink-0 items-center justify-center gap-2 rounded-full px-2 text-sm font-medium text-slate-600 hover:bg-slate-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-500 dark:text-slate-300 dark:hover:bg-slate-800"
      onClick={() => {
        onOpen?.()
        search.openSearch()
      }}
    >
      <Search className="h-5 w-5" aria-hidden="true" />
      {label && (
        <>
          <span className="hidden xl:inline">Search</span>
          <kbd className="hidden 2xl:inline text-xs text-slate-400">⌘K</kbd>
        </>
      )}
    </button>
  )
}
